import { NSARouterMakerResult } from "namirasoft-account-react"
import { useParams } from "react-router-dom"
import "reactflow/dist/style.css"
import { InfraLayout } from "../InfraLayout"
import { InfraRouterProps } from "../InfraRouterProps"
import ProjectDiagram from "../components/ProjectDiagram"

export interface ProjectDiagramPageProps extends NSARouterMakerResult, InfraRouterProps { }

function ProjectDiagramPage(props: ProjectDiagramPageProps)
{
    const { "project-id": project_id } = useParams();
    const { "environment-id": environment_id } = useParams();

    return (
        <InfraLayout
            {...props}
            action={{
                title: "Project Diagram"
            }}
        >
            <>
                {
                    project_id && environment_id &&
                    <ProjectDiagram {...props} project_id={project_id} environment_id={environment_id} />
                }
            </>
        </InfraLayout >
    )
}

export default ProjectDiagramPage;